var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-none",attrs:{"id":"all-packages-label-template"}},_vm._l((_vm.packages),function(p){return _c('PackageLabelTemplate',{key:p.id,attrs:{"context":p}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }